export default {
    library: [
        { key: 'alien', faIcon: 'alien', notoEmojiId: '1f47d' },
        { key: 'bat', faIcon: 'bat', notoEmojiId: '1f987' },
        { key: 'bicycle', faIcon: 'bicycle', notoEmojiId: '1f6b2' },
        { key: 'car', faIcon: 'car', notoEmojiId: '1f697' },
        { key: 'cat', faIcon: 'cat', notoEmojiId: '1f63a' },
        { key: 'clap', faIcon: 'hands-clapping', notoEmojiId: '1f44f' },
        { key: 'coin', faIcon: 'coin', notoEmojiId: '1fa99' },
        { key: 'cold', faIcon: 'face-icicles', notoEmojiId: '1f976' },
        { key: 'crystal-ball', faIcon: 'crystal-ball', notoEmojiId: '1f52e' },
        { key: 'blowfish', faIcon: 'fish', notoEmojiId: '1f421' },
        { key: 'clock', faIcon: 'clock', notoEmojiId: '23f0' },
        { key: 'cross', faIcon: 'x', notoEmojiId: '274c' },
        { key: 'dinosaur', faIcon: 'dinosaur', notoEmojiId: '1f995' },
        { key: 'dog', faIcon: 'dog', notoEmojiId: '1f415' },
        { key: 'dragon', faIcon: 'dragon', notoEmojiId: '1f409' },
        { key: 'electric', faIcon: 'bolt', notoEmojiId: '26a1' },
        { key: 'eyes', faIcon: 'eyes', notoEmojiId: '1f440' },
        { key: 'fight', faIcon: 'boxing-glove', notoEmojiId: '1faef' },
        { key: 'flying-money', faIcon: 'money-bill-1-wave', notoEmojiId: '1f4b8' },
        { key: 'flying-saucer', faIcon: 'ufo', notoEmojiId: '1f6f8' },
        { key: 'frog', faIcon: 'frog', notoEmojiId: '1f438' },
        { key: 'gear', faIcon: 'gear', notoEmojiId: '2699_fe0f' },
        { key: 'gem', faIcon: 'gem', notoEmojiId: '1f48e' },
        { key: 'ghost', faIcon: 'ghost', notoEmojiId: '1f47b' },
        { key: 'globe', faIcon: 'earth-americas', notoEmojiId: '1f30e' },
        { key: 'handshake', faIcon: 'handshake', notoEmojiId: '1faf1_1f3fb_200d_1faf2_1f3fd' },
        { key: 'heart', faIcon: 'heart', notoEmojiId: '2764_fe0f' },
        { key: 'imp', faIcon: 'face-smile-horns', notoEmojiId: '1f608' },
        { key: 'laugh', faIcon: 'face-grin-tears', notoEmojiId: '1f602' },
        { key: 'light-bulb', faIcon: 'lightbulb', notoEmojiId: '1f4a1' },
        { key: 'medal', faIcon: 'medal', notoEmojiId: '1f947' },
        { key: 'monkey', faIcon: 'monkey', notoEmojiId: '1f412' },
        { key: 'paw', faIcon: 'paw', notoEmojiId: '1f43e' },
        { key: 'peeking', faIcon: 'face-hand-peeking', notoEmojiId: '1fae3' },
        { key: 'plane-departure', faIcon: 'plane-departure', notoEmojiId: '1f6eb' },
        { key: 'question', faIcon: 'question', notoEmojiId: '2753' },
        { key: 'rabbit', faIcon: 'rabbit', notoEmojiId: '1f407' },
        { key: 'robot', faIcon: 'robot', notoEmojiId: '1f916' },
        { key: 'rocket', faIcon: 'rocket', notoEmojiId: '1f680' },
        { key: 'sad', faIcon: 'face-frown', notoEmojiId: '2639_fe0f' },
        { key: 'seedling', faIcon: 'seedling', notoEmojiId: '1f331' },
        { key: 'smile', faIcon: 'face-smile', notoEmojiId: '1f600' },
        { key: 'snowflake', faIcon: 'snowflake', notoEmojiId: '2744_fe0f' },
        { key: 'snowman', faIcon: 'snowman', notoEmojiId: '2603_fe0f' },
        { key: 'soccer-ball', faIcon: 'futbol', notoEmojiId: '26bd' },
        { key: 'space-invader', faIcon: 'alien-8bit', notoEmojiId: '1f47e' },
        { key: 'spider', faIcon: 'spider', notoEmojiId: '1f577_fe0f' },
        { key: 'star', faIcon: 'star', notoEmojiId: '1f31f' },
        { key: 'splatter', faIcon: 'splotch', notoEmojiId: '1fadf' },
        { key: 'tennis', faIcon: 'tennis-ball', notoEmojiId: '1f3be' },
        { key: 'thinking', faIcon: 'face-thinking', notoEmojiId: '1f914' },
        { key: 'tiger', faIcon: 'paw-claws', notoEmojiId: '1f405' },
        { key: 'trophy', faIcon: 'trophy', notoEmojiId: '1f3c6' },
        { key: 'thumbs-up', faIcon: 'thumbs-up', notoEmojiId: '1f44d' },
        { key: 'unicorn', faIcon: 'unicorn', notoEmojiId: '1f984' }
    ],
    default: ['smile', 'laugh', 'sad', 'clap', 'thumbs-up', 'heart'],
    themes: [
        { shortname: 'fairy-tales', emojis: ['crystal-ball', 'unicorn', 'dragon'] },
        { shortname: 'extreme-sports', emojis: ['peeking'] },
        { shortname: 'amazing-animals', emojis: ['monkey', 'rabbit', 'blowfish'] },
        { shortname: 'abstract-art', emojis: ['eyes', 'splatter'] },
        { shortname: 'green-future', emojis: ['seedling', 'electric', 'globe'] },
        { shortname: 'platformer-games', emojis: ['star', 'coin', 'gem'] },
        { shortname: 'magical-creatures', emojis: ['unicorn', 'dragon', 'imp'] },
        { shortname: 'planetary-exploration', emojis: ['flying-saucer', 'rocket', 'globe'] },
        { shortname: 'haunted-house', emojis: ['ghost', 'imp', 'bat'] },
        { shortname: 'snow-day', emojis: ['snowflake', 'cold', 'snowman'] },
        { shortname: 'quiz-games', emojis: ['question', 'thinking', 'cross'] },
        { shortname: 'start-a-business', emojis: ['light-bulb', 'handshake', 'flying-money'] },
        { shortname: 'code-safari', emojis: ['monkey', 'tiger', 'eyes'] },
        { shortname: 'build-your-own-worlds', emojis: ['globe', 'car', 'bicycle'] },
        { shortname: 'journey-through-time', emojis: ['clock', 'robot', 'dinosaur'] },
        { shortname: 'awesome-aviation', emojis: ['plane-departure', 'rocket', 'flying-saucer'] },
        { shortname: 'code-adventure', emojis: ['gem', 'unicorn', 'dragon'] },
        { shortname: 'gateway', emojis: ['rocket', 'space-invader', 'flying-saucer'] },
        { shortname: 'inventors-workshop', emojis: ['electric', 'light-bulb', 'gear'] },
        { shortname: 'superheroes', emojis: ['electric', 'fight', 'spider'] },
        { shortname: 'science-fiction', emojis: ['alien', 'flying-saucer', 'rocket'] },
        { shortname: 'trick-or-code-camp', emojis: ['ghost', 'imp', 'bat'] },
        { shortname: 'spooky-season', emojis: ['ghost', 'imp', 'bat'] },
        { shortname: 'ai-adventurers', emojis: ['thinking', 'robot'] },
        { shortname: 'arcade-museum', emojis: ['electric', 'frog', 'space-invader'] },
        { shortname: 'pet-pals', emojis: ['dog', 'cat', 'unicorn'] },
        { shortname: 'goal-rush', emojis: ['soccer-ball', 'robot', 'trophy'] },
        { shortname: 'game-set-code', emojis: ['tennis', 'medal', 'trophy'] },
        { shortname: 'virtual-pets', emojis: ['dog', 'cat', 'paw'] },
    ]

    // Winter Wonderland
    // { key: 'snowflake', faIcon: 'snowflake', notoEmojiId: '2744_fe0f' },
    // { key: 'cold', faIcon: 'face-icicles', notoEmojiId: '1f976' },

    // Robotics
    // { key: 'robot', faIcon: 'robot', notoEmojiId: '1f916' },
    // { key: 'arm-mechanical', faIcon: 'hand-fist', notoEmojiId: '1f9be' },

    // { key: 'rainbow', faIcon: 'rainbow', notoEmojiId: '1f308' },
    // { key: 'pencil', faIcon: 'pencil', notoEmojiId: '270f_fe0f' },

    // { key: 'collision', faIcon: 'pencil', notoEmojiId: '1f4a5' },


    // Sports
    // { key: 'tennis-racquet', faIcon: 'racquet', notoEmojiId: '1f3be' },
    // { key: 'soccer-ball', faIcon: 'futbol', notoEmojiId: '26bd' },
    // { key: 'bowling', faIcon: 'bowling-ball-pin', notoEmojiId: '1f3b3' },

    // Under the Sea
    // { key: 'blowfish', faIcon: 'fish', notoEmojiId: '1f421' },
    // { key: 'octopus', faIcon: 'octopus', notoEmojiId: '1f419' },
    // { key: 'ocean', faIcon: 'wave', notoEmojiId: '1f30a' },

    // Puzzles
    // { key: 'thinking', faIcon: 'face-thinking', notoEmojiId: '1f914' },
    // { key: 'light-bulb', faIcon: 'lightbulb', notoEmojiId: '1f4a1' },
    // { key: 'monocle', faIcon: 'face-monocle', notoEmojiId: '1f9d0' },

    // // World Travel
    // { key: 'world', faIcon: 'earth-americas', notoEmojiId: '1f30e' },
    // { key: 'plane-departure', faIcon: 'plane-departure', notoEmojiId: '1f6eb' },

    // Obstacle Courses
    // { key: 'construction', faIcon: 'road-barrier', notoEmojiId: '1f6a7' },
    // { key: 'chequered-flag', faIcon: 'flag-checkered', notoEmojiId: '1f3c1' },

    // Multiplayer Games
    // { key: 'tennis-racquet', faIcon: 'racquet', notoEmojiId: '1f3be' },
    // { key: 'dice', faIcon: 'dice', notoEmojiId: '1f3b2' },
    // { key: 'bowling', faIcon: 'bowling-ball-pin', notoEmojiId: '1f3b3' },

    // Avatars
    // { key: 'robot', faIcon: 'robot', notoEmojiId: '1f916' },
    // { key: 'unicorn', faIcon: 'unicorn', notoEmojiId: '1f984' },
    // { key: 't-rex', faIcon: 't-rex', notoEmojiId: '1f996' },

    // // Run a Restaurant
    // { key: 'yum', faIcon: 'face-smile-tongue', notoEmojiId: '1f60b' },
    // { key: 'frying', faIcon: 'pan-frying', notoEmojiId: '1f373' },
    // { key: 'tomato', faIcon: 'tomato', notoEmojiId: '1f345' },
};